import { render, staticRenderFns } from "./work-step.vue?vue&type=template&id=4d1a0612&scoped=true&"
var script = {}
import style0 from "./work-step.vue?vue&type=style&index=0&id=4d1a0612&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1a0612",
  null
  
)

export default component.exports